import { render, staticRenderFns } from "./visit-list.vue?vue&type=template&id=275d047c&scoped=true"
import script from "./visit-list.vue?vue&type=script&lang=js"
export * from "./visit-list.vue?vue&type=script&lang=js"
import style0 from "./visit-list.vue?vue&type=style&index=0&id=275d047c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275d047c",
  null
  
)

export default component.exports